import React, { HTMLAttributes } from "react";

import { isNotSet } from "@/tools/format.checker";

import useCounter from "../../../hooks/useCounter/useCounter";

type InputElement = HTMLAttributes<{}>;

type OwnProps = {
  placeholder?: string;
  className?: string;
  label?: string;
  inputMode?: InputElement["inputMode"];
  resend?: boolean;
  resendCb?: () => void;
  maxLength?: number;
  minLength?: number;

  onChange: (...event: any[]) => void;
  onBlur: () => void;
  value: any;
  name: string;
  error: string | void;
  touched: boolean | void;
};

type Props = OwnProps;

const NumberFields: React.FC<Props> = ({
  label,
  className = "",
  placeholder,
  inputMode,
  resend,
  resendCb,
  maxLength,
  minLength,

  onChange,
  onBlur,
  value,
  name,
  error,
  touched,
}) => {
  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (!isNotSet(value.match(/[^\d]/g)!)) return;
    onChange(e);
  };

  const { counter, restart } = useCounter(30);

  const onResendClick = () => {
    if (resendCb) {
      restart();
      resendCb();
    }
  };

  return (
    <div
      className={`input ${className ? `${className}__input--container` : ""}`}
    >
      <label
        className={`input__label ${className ? `${className}__label` : ""}`}
      >
        {label}
        {resend &&
          (counter === 0 ? (
            <button
              type={"button"}
              className="btn__resend"
              onClick={onResendClick}
            >
              重新發送
            </button>
          ) : (
            <span className="btn__resend">{counter}秒後可重新發送</span>
          ))}
      </label>
      <input
        className={`input__input ${className ? `${className}__input` : ""}`}
        placeholder={placeholder}
        onBlur={onBlur}
        onChange={onInputChange}
        value={value}
        name={name}
        inputMode={inputMode}
        maxLength={maxLength}
        minLength={minLength}
      />
      {touched && error && (
        <span
          className={`input__error ${className ? `${className}__error` : ""}`}
        >
          {error}
        </span>
      )}
    </div>
  );
};

export default NumberFields;
